import { useApi } from '@backstage/core-plugin-api';
import useAsync from 'react-use/esm/useAsync';
import { kubernetesProxyApiRef } from '../../../api/types.esm.js';

const useEvents = ({
  involvedObjectName,
  namespace,
  clusterName
}) => {
  const kubernetesProxyApi = useApi(kubernetesProxyApiRef);
  return useAsync(async () => {
    return await kubernetesProxyApi.getEventsByInvolvedObjectName({
      involvedObjectName,
      namespace,
      clusterName
    });
  }, [involvedObjectName, namespace, clusterName]);
};

export { useEvents };
//# sourceMappingURL=useEvents.esm.js.map
